import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store/index";
import App from "./App.tsx";
import { MantineProvider } from "@labeling-tools/ui-components";
import { PostHogProvider } from "@posthog/react";
import "./index.css";
import "@mantine/core/styles.css";
import "@mantine/carousel/styles.css";
import "@mantine/dates/styles.css";
// Side effect: injects @augmodo/reusable-components' CSS (bypassing the
// Tailwind 3 postcss pass — see the module for why).
import "./inject-reusable-components-css";

const options = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  defaults: "2025-05-24",
  disable_session_recording: true,
} as const;

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <MantineProvider>
      <Provider store={store}>
        <BrowserRouter>
          <PostHogProvider
            apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
            options={options}
          >
            <App />
          </PostHogProvider>
        </BrowserRouter>
      </Provider>
    </MantineProvider>
  </React.StrictMode>,
);
